// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.choose-module-page{margin-bottom:6rem}`, "",{"version":3,"sources":["webpack://./src/Pages/Training/ChooseModulePage/ChooseModulePage.style.scss"],"names":[],"mappings":"AAAA,oBACC,kBAAA","sourcesContent":[".choose-module-page{\n margin-bottom : 6rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
